var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9004 1.90295L10.1004 6.70295V22.0971L14.9004 17.2971V1.90295Z",
    fill: "#3AB44A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.94892 3.95148C4.60572 3.60828 4.08958 3.50562 3.64117 3.69136C3.19276 3.87709 2.90039 4.31466 2.90039 4.80001V16.8C2.90039 17.1183 3.02682 17.4235 3.25186 17.6485L7.70039 22.0971V6.70295L4.94892 3.95148Z",
    fill: "#3AB44A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7489 6.35148L17.3004 1.90295V17.2971L20.0519 20.0485C20.3951 20.3917 20.9112 20.4944 21.3596 20.3087C21.808 20.1229 22.1004 19.6854 22.1004 19.2V7.20001C22.1004 6.88175 21.974 6.57653 21.7489 6.35148Z",
    fill: "#3AB44A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapGreen);
export default __webpack_public_path__ + "static/media/map-green.c2d5a21b4c0f1ab4ae8e0d87c83d4033.svg";
export { ForwardRef as ReactComponent };